import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { InitializePropsOptions, ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { Feedbacks } from '@/utils/feedback.utils';
import { htmlToXmlFragment } from '@/utils/tiptap';
import { createNewFlexSectionData } from '@/widgets/FlexSection/create';
import { FlexSectionDirection } from '@/widgets/FlexSection/types';
import { manifestLocales } from '@/widgets/QuestionGroupList/manifest.locales';
import { GroupCheckButtonMode, ParentHeadline, QuestionListBulletTypes } from '@/widgets/QuestionGroupList/types';
import { getEvaluationProps } from '@/widgets/consts/getEvaluationProps';
import { RelativeScoreMode } from '@/widgets/types/questionScoreMode';

export function createNewQuestionGroupList(options: InitializePropsOptions): ManifestInitializedProps {
  const { isPlenaryLesson, locale } = options;
  const { initialHeadlineText } = manifestLocales.questionGroupList;
  const id = genRandId();
  const labelFragment = htmlToXmlFragment(`<h2><span>${initialHeadlineText[locale]}</span></h2>`);
  const descriptionFragment = new Y.XmlFragment();
  const hintFragment = htmlToXmlFragment('<p></p>');
  const widgetEvaluationProps = Object.entries(getEvaluationProps(isPlenaryLesson));

  const [verticalSectionData] = createNewFlexSectionData(FlexSectionDirection.column);
  const { id: verticalSectionId } = verticalSectionData;
  const childrenArray = new Y.Array();
  childrenArray.push([verticalSectionId]);

  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.QuestionGroupList],
        ['children', childrenArray],
        ['labelFragment', labelFragment],
        ['descriptionFragment', descriptionFragment],
        ['hintFragment', hintFragment],
        ['withRandomSubQuestions', true],
        ['feedback', Feedbacks.Check],
        ['groupCheckButtonMode', GroupCheckButtonMode.GeneralButton],
        ['parentHeadline', ParentHeadline.Manual],
        ['questionListBulletType', QuestionListBulletTypes.Number],
        ['relativeScoreMode', RelativeScoreMode.RelativeToParent],
        ['showGeneralGrade', true],
        ['showEachQuestionGrade', false],
        ['choiceQuestionsEnabled', false],
        ['choiceQuestionsCount', 0],
        ['visibleQuestionsCount', 0],
        ['requiredSubQuestionsId', []],
        ['saveAnswers', true],
        ...widgetEvaluationProps
      ])
    },
    verticalSectionData
  ];
}
